import React from 'react';
import styled from 'styled-components';
import { focusRing, primitiveColors, transition } from '@/styles/template';

interface AProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
	white?: boolean;
}

const A = styled.a<AProps>`
  cursor: pointer;
  color: ${primitiveColors.primary[500]};
  transition: ${transition.fastEnd};
  border-bottom: 1px solid transparent;

  ${focusRing}

  /* Реакция только на устройствах с реальным указателем — на тач :hover
     «залипает» после тапа, из-за чего цвет/подчёркивание ссылки остаётся
     активным до следующего тапа. См. тот же паттерн в DottedLink. */
  @media (hover: hover) {
    &:hover {
      opacity: .8;
      border-bottom-color: ${primitiveColors.primary[500]};
    }
  }
`;

export default A;